import {Dispatch} from "redux";

import {patchRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiLink} from "@pg-mono/rp-api-routes";

import {applicationCancelHit} from "../../../tracking/algolytics_hits/application_hit";

const DISMISS_LEAD = "shared/DISMISS_LEAD";

export const dismissLeadRequestTypes = createRequestActionTypes(DISMISS_LEAD);
export const patchDismissLead = (uuid: string) => (dispatch: Dispatch) => {
    const dismissLeadApiLink = apiLink.application.update({});
    dispatch({type: dismissLeadRequestTypes.start});
    const callAlertAndHitAlgolytics = (uuid: string) => {
        applicationCancelHit(uuid);
    };
    return patchRequest({}, dismissLeadApiLink({uuid}), {uuid, schedule_cancelled_date: new Date()})
        .then((application: {uuid: string}) => {
            callAlertAndHitAlgolytics(uuid);
            dispatch({type: dismissLeadRequestTypes.success, result: application});
            return application;
        })
        .catch((err) => {
            dispatch({type: dismissLeadRequestTypes.error, error: err.message});
            // notifyBugsnagClient(err, "patchDismissLead", err.message);
        });
};
import {Dispatch} from "redux";

import {patchRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiLink} from "@pg-mono/rp-api-routes";

import {applicationCancelHit} from "../../../tracking/algolytics_hits/application_hit";

const DISMISS_LEAD = "shared/DISMISS_LEAD";

export const dismissLeadRequestTypes = createRequestActionTypes(DISMISS_LEAD);
export const patchDismissLead = (uuid: string) => (dispatch: Dispatch) => {
    const dismissLeadApiLink = apiLink.application.update({});
    dispatch({type: dismissLeadRequestTypes.start});
    const callAlertAndHitAlgolytics = (uuid: string) => {
        applicationCancelHit(uuid);
    };
    return patchRequest({}, dismissLeadApiLink({uuid}), {uuid, schedule_cancelled_date: new Date()})
        .then((application: {uuid: string}) => {
            callAlertAndHitAlgolytics(uuid);
            dispatch({type: dismissLeadRequestTypes.success, result: application});
            return application;
        })
        .catch((err) => {
            dispatch({type: dismissLeadRequestTypes.error, error: err.message});
            // notifyBugsnagClient(err, "patchDismissLead", err.message);
        });
};
